import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedToasterService } from '../../../shared/services/shared-toaster.service';
import { NotificationDetailsModel } from '../../models/notification-details.model';
import { NotificationsRedirectService } from '../../services/notifications-redirect.service';
import { NotificationsStateService } from '../../services/notifications-state.service';
import { NotificationsService } from '../../services/notifications.service';

@Component({
    templateUrl: './notification-details-component.html',
    styleUrl: './notification-details-component.scss'
})
export class NotificationsDetailsComponent implements OnInit {
    protected areDetailsVisible = false;
    protected details: NotificationDetailsModel | null = null;
    protected actionLinkUrl: string | null = null;
    protected actionLinkText: string | null = null;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly notificationService: NotificationsService,
        private readonly redirectService: NotificationsRedirectService,
        private readonly sharedToasterService: SharedToasterService,
        private readonly notificationsStateService: NotificationsStateService,
        private readonly router: Router
    ) { }

    ngOnInit(): void {
        const notificationId = this.route.snapshot.paramMap.get('id');
        if (!notificationId) return;

        this.loadNotificationById(notificationId);
    }

    private loadNotificationById(notificationId: string): void {
        this.notificationService.getNotificationById(notificationId).subscribe({
            next: (model: NotificationDetailsModel) => {
                this.details = model;
                this.notificationsStateService.loadNotificationsAsync();
                this.redirectOrDisplay();
            },
            error: () => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    private redirectOrDisplay() {
        if (this.details == null) return;
        const redirectUrl = this.redirectService.getNotificationAutoRedirectPath(this.details.source, this.details.sourceId);

        if (redirectUrl == null) {
            this.areDetailsVisible = true;
            this.actionLinkText = this.redirectService.getNotificationManuarlActionName(this.details.source);
            this.actionLinkUrl = this.redirectService.getNotificationManuarlActionUrl(this.details.source);
            return;
        }

        this.router.navigateByUrl(redirectUrl);

    }
}